import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Box, Container,
  Flex,
  Heading,
  IconButton,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

//import RenderResource from "./RenderResource";
import { getCandidateDetail } from "../Api";
import { Paths, QuestionType, SkillType } from "../model/Constants";
import { AnswerDto } from "../model/Dto";
import { adminKeys } from "../QueryKeys";
import { displayCandidateStatus, displayTime, extractData } from "../Utils";
import AudioPlayer from "./AudioPlayer";
import Markdown from "./Markdown";

const CandidateDetail = () => {
  const params = useParams<{ username: string, publicId: string, candidateToken: string }>();
  const username = params.username || "";
  const candidateToken = params.candidateToken || "";
  const testPublicId = params.publicId || "";
  const navigate = useNavigate();

const base64ToBlob = (base64:any, type:any) => {
  // Decode base64 string to binary data
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type });
};

  const candidateQuery = useQuery(adminKeys.candidateDetail(testPublicId, candidateToken), () =>
    getCandidateDetail(username, testPublicId, candidateToken).then(extractData)
  );

  function displayCorrect(answer:AnswerDto) {
    let correct="";
    if (answer.question.questionType===QuestionType.MULTIPLE_CHOICE) {
        correct=answer.correct?"Correcta":"Incorrecta";
    } else {
        correct=answer.correct?"Respuesta guardada correctamente":"La respuesta posiblemente esté vacía";
    }
    return correct;
  }

  if (!candidateQuery.data) {
    return <Spinner />;
  } else {
    candidateQuery.data.answers.sort((a, b) => a.answerOrder - b.answerOrder);
    return (
      <Container maxW="container.lg" marginX="auto">
          <Heading as="h2" size='xl'>Reporte de respuestas</Heading>
          <Heading as="h3" size='md'>{candidateQuery.data.username} - {candidateQuery.data.name}</Heading>
          <Heading as="h3"size='md'>{candidateQuery.data.testName} - {candidateQuery.data.testPublicId} - {candidateQuery.data.skillType}</Heading>

          <Heading as="h4"size='sm'>{displayCandidateStatus(candidateQuery.data.status)} - {candidateQuery.data.level}</Heading>
          <Text>Inicio: {displayTime(candidateQuery.data.startTime)}</Text>
          <Text>Fin: {displayTime(candidateQuery.data.endTime)}</Text>

        <Text>Respuestas</Text>

        {candidateQuery.data.answers.map((answer) => (
          <Box
            key={answer.question.code}
            marginTop="2"
            marginBottom="2"
            padding="2"
            borderWidth="1px"
            borderRadius="lg"
            borderColor="gray.300"
            borderStyle="solid"
          >
            <Text>#{answer.answerOrder} -  {answer.question.code} - {answer.question.level}</Text>
            <Markdown content={answer.question.instructions}  />
            <Markdown content={answer.question.body}  />
            <Markdown content={answer.question.statement}  />

            { answer.question.questionType===QuestionType.MULTIPLE_CHOICE &&
              answer.question.options!==undefined &&
                answer.question.options.map((option) => (
                    <Text>{option.option} -  {option.text}</Text>
                ))
            }


            { answer.question.questionType===QuestionType.MULTIPLE_CHOICE &&
              answer.selectedOptions!==undefined &&
                answer.selectedOptions.map((option) => (
                  <Box
                    key={option.option}
                    marginTop="2"
                    marginBottom="2"
                    padding="2"
                    borderWidth="1px"
                    borderRadius="lg"
                    borderColor="gray.300"
                    borderStyle="solid"
                  >
                    <Text>{option.option}</Text>
                    <Text>{displayCorrect(answer)}</Text>
                  </Box>
                ))
            }
            { answer.question.questionType===QuestionType.COMPOSITION &&
                candidateQuery.data.skillType === SkillType.SPEAKING &&
                answer.answerBlob!==null && answer.answerBlob!==undefined &&
                <>
                    <Text>{displayCorrect(answer)}</Text>
                <AudioPlayer
                    sourceUrl={URL.createObjectURL(base64ToBlob(answer.answerBlob, "audio/wav"))}
                    maxNumberOfReproductions={0}
                />
                </>
            }
          </Box>
        ))}
      </Container>
    );
  }
};

export default CandidateDetail;
